import React from 'react';
import styles from './ContactCard.module.css';

export default function ContactCard({ isDefault, name, title, email, phone, address1 = '-', address2 = '-' }) {
  return (
    <div className={isDefault ? styles.defaultContactCard : styles.contactCard}>
      {isDefault && <div className={styles.defaultContactHeader}>Default Contact</div>}
      <div className={styles.row}>
        <div className={styles.subRowLabel}>Name</div>
        <div className={styles.rowValue}>{name}</div>
      </div>
      <div className={styles.row}>
        <div className={styles.subRowLabel}>Title</div>
        <div className={styles.rowValue}>{title}</div>
      </div>
      <div className={styles.row}>
        <div className={styles.subRowLabel}>Email</div>
        <div className={styles.rowValue}>{email}</div>
      </div>
      <div className={styles.row}>
        <div className={styles.subRowLabel}>Phone</div>
        <div className={styles.rowValue}>{phone}</div>
      </div>
      <div className={styles.row}>
        <div className={styles.subRowLabel}>Address</div>
        <div className={styles.rowValue}>{address1}</div>
      </div>
      <div className={styles.row}>
        <div className={styles.subRowLabel}>City, State ZIP</div>
        <div className={styles.rowValue}>{address2}</div>
      </div>
    </div>
  );
}
